// Copyright (c) StrangeBee 2024

import { CaseCustomField, CustomFieldValueInput } from 'thehive-sdk';
import { generateId } from './string';

export const convertOldCustomFields = (customFields?: {
    [key: string]: {
        [type: string]: any;
    };
}): CustomFieldValueInput[] =>
    Object.entries(customFields || {}).map(([cfName, content]) => {
        const [type, value] = Object.entries(content)[0];

        return {
            name: cfName,
            type: type as any,
            value,
        };
    });

export const convertCustomFields = (
    customFields: CaseCustomField[],
): ({ name: string; value: any; order: number } | undefined)[] => {
    return customFields?.reduce((acc, cf) => {
        return !!cf
            ? [
                  ...acc,
                  {
                      name: cf.name,
                      value:
                          cf.value === ''
                              ? null
                              : cf.value === 'true'
                              ? true
                              : cf.value === 'false'
                              ? false
                              : cf.value !== undefined
                              ? cf.value
                              : null,
                      order: cf.order,
                  },
              ]
            : acc;
    }, [] as { name: string; value: any; order: number }[]);
};

export const mergeCF = (
    customFieldsOrigin: CaseCustomField[],
    customFieldsExtern: CaseCustomField[],
    customFieldsUpdated: CaseCustomField[],
): CaseCustomField[] => {
    const customFieldsOriginMap = customFieldsOrigin.reduce<Record<string, CaseCustomField>>((acc, cf) => {
        acc[cf._id] = cf;
        return acc;
    }, {});

    const customFieldsExternMap = customFieldsExtern.reduce<Record<string, CaseCustomField>>((acc, cf) => {
        acc[cf._id] = cf;
        return acc;
    }, {});

    const customFieldsUpdatedMap = customFieldsUpdated.reduce<Record<string, CaseCustomField>>((acc, cf) => {
        acc[cf._id || generateId()] = cf;
        return acc;
    }, {});

    const customFieldsMerged = Object.values(customFieldsUpdatedMap).map((cf) => {
        const state = cf._id ? 'old' : 'new';

        if (state === 'old') {
            const youngerCF = cf.value === customFieldsOriginMap[cf._id]?.value ? customFieldsExternMap[cf._id] : cf;
            delete customFieldsOriginMap[cf._id];
            delete customFieldsExternMap[cf._id];
            return youngerCF;
        }

        return cf;
    });

    return [
        ...customFieldsMerged,
        ...Object.values(customFieldsExternMap).filter((cf) => !customFieldsOriginMap[cf._id]),
    ];
};
